/** Politique mot de passe — alignée sur backend (adminValidator, authValidator). */

export const PASSWORD_MIN_LENGTH = 6;
export const PASSWORD_MAX_LENGTH = 128;

const HAS_LOWER = /[a-z]/;
const HAS_UPPER = /[A-Z]/;
const HAS_DIGIT = /\d/;
const STRENGTH_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/;

export function getPasswordChecks(password = '') {
  const value = String(password);
  return [
    {
      id: 'length',
      label: `Au moins ${PASSWORD_MIN_LENGTH} caractères`,
      ok: value.length >= PASSWORD_MIN_LENGTH
    },
    {
      id: 'lower',
      label: 'Une lettre minuscule (a–z)',
      ok: HAS_LOWER.test(value)
    },
    {
      id: 'upper',
      label: 'Une lettre majuscule (A–Z)',
      ok: HAS_UPPER.test(value)
    },
    {
      id: 'digit',
      label: 'Un chiffre (0–9)',
      ok: HAS_DIGIT.test(value)
    }
  ];
}

export function isPasswordStrong(password) {
  const value = String(password);
  if (!value || value.length > PASSWORD_MAX_LENGTH) return false;
  return STRENGTH_REGEX.test(value) && value.length >= PASSWORD_MIN_LENGTH;
}

export function validatePassword(value, { required = true } = {}) {
  if (!value) {
    return required ? 'Le mot de passe est requis' : null;
  }
  if (value.length < PASSWORD_MIN_LENGTH) {
    return `Le mot de passe doit contenir au moins ${PASSWORD_MIN_LENGTH} caractères`;
  }
  if (value.length > PASSWORD_MAX_LENGTH) {
    return `Le mot de passe ne peut pas dépasser ${PASSWORD_MAX_LENGTH} caractères`;
  }
  if (!STRENGTH_REGEX.test(value)) {
    return 'Le mot de passe doit contenir au moins une minuscule, une majuscule et un chiffre';
  }
  return null;
}
